import { render, staticRenderFns } from "./images-carousel.vue?vue&type=template&id=7c5d5fd2&scoped=true"
import script from "./images-carousel.vue?vue&type=script&lang=js"
export * from "./images-carousel.vue?vue&type=script&lang=js"
import style0 from "./images-carousel.vue?vue&type=style&index=0&id=7c5d5fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5d5fd2",
  null
  
)

export default component.exports